import BasePopup from "../../../../src/scripts/classes/BasePopup";

var PopupInfo = function(options) {
	// Call parent constructor
	BasePopup.call(this, $.extend(true, {
		baseClass: 'el-PopupInfo',
		dotSelector: '.text-popup_element-wrapper',
		popupSelector: '.text-popup_tooltip-wrapper',
		pointerSelector: '.text-popup_pointer',
		componentName: 'PopupInfo'
	}, options));
};

// Inherit from BasePopup
PopupInfo.prototype = Object.create(BasePopup.prototype);
PopupInfo.prototype.constructor = PopupInfo;

export default PopupInfo;
